var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { useI18n } from '@oneaudi/i18n-context';
import { TextButton } from '@oneaudi/unified-web-components';
import { useServicesContext } from '../../../../../context';
import { useRethinkFSCheckoutPostData, fsCheckoutPostRequest, } from '../../../../../utils/fsCheckoutCTA';
import { FinanceCheckoutLayer } from './FinanceCheckout/FinanceCheckoutLayer';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
export const FinanceCheckoutPopoverButton = ({ buttonInfo, vehicle, useFinanceData, trackButtonClick, variant, scContextId, isMobileScreenSize, isLoading, isRenderedInConversionBar, IsLayerOpenedFromConversionBar, onClickToCloseFSPopup, }) => {
    const layerManager = useServicesContext().getAdditionalService('gfa:layer-manager');
    const financeCheckoutTranslations = {
        financeCheckoutAriaBtn: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.financeCheckoutAriaBtn`,
        }),
        financeCheckoutOuterLayer: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.outer.financeCheckoutLayer.ariaLabel`,
        }),
        financeCheckoutInnerLayer: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.inner.financeCheckoutLayer.ariaLabel`,
        }),
    };
    const [isApiInprogress, setIsApiInprogress] = useState(false);
    const [IsOpenedFromConversionBar, setIsOpenedFromConversionBar] = useState(IsLayerOpenedFromConversionBar);
    const [fsCheckoutLink, setFsCheckoutLink] = useState(buttonInfo.notFoundPageUrl);
    const [focusLayerNode, setFocusLayerNode] = React.useState();
    const [focusLayer, setFocusLayer] = React.useState();
    useEffect(() => {
        if (IsOpenedFromConversionBar) {
            openFocusLayer();
            trackButtonClick(buttonInfo, variant);
        }
    }, [IsOpenedFromConversionBar]);
    const postDataFSCheckout = () => {
        let postCheckoutData;
        if (typeof document !== 'undefined') {
            try {
                postCheckoutData = useRethinkFSCheckoutPostData(vehicle, buttonInfo.dataProfile, vehicle.countryCode, vehicle.langCode, scContextId, useFinanceData);
            }
            catch (error) {
                console.error('Error fetching postCheckoutData:', error);
            }
        }
        return postCheckoutData;
    };
    const fsOnBtnClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsApiInprogress(true);
            const postData = yield postDataFSCheckout();
            const fsLink = yield fsCheckoutPostRequest(buttonInfo.url, postData);
            setFsCheckoutLink(fsLink);
        }
        catch (_a) {
            setFsCheckoutLink(buttonInfo.notFoundPageUrl);
        }
        setIsApiInprogress(false);
        trackButtonClick(Object.assign(Object.assign({}, buttonInfo), { label: buttonInfo.label, url: '' }), variant, buttonInfo.trackingCode, 'click on');
    });
    const focusLayerRef = React.useCallback((node) => {
        setFocusLayerNode(node);
    }, [setFocusLayerNode]);
    const openFocusLayer = () => {
        const layer = layerManager.openFocusLayer(() => React.createElement("div", { ref: focusLayerRef }), {
            primaryAriaLabel: financeCheckoutTranslations.financeCheckoutOuterLayer,
            secondaryAriaLabel: financeCheckoutTranslations.financeCheckoutInnerLayer,
        }, {
            size: "A",
            userCloseable: true,
            onClose: () => {
                closeFocusLayer();
            },
        });
        fsOnBtnClick();
        setFocusLayer(layer);
    };
    const closeFocusLayer = () => {
        focusLayer === null || focusLayer === void 0 ? void 0 : focusLayer.close();
        if (IsOpenedFromConversionBar) {
            setIsOpenedFromConversionBar(false);
            onClickToCloseFSPopup();
        }
    };
    return (React.createElement(React.Fragment, { key: buttonInfo.type },
        focusLayerNode &&
            ReactDOM.createPortal(React.createElement(FinanceCheckoutLayer, { buttonInfo: buttonInfo, trackButtonClick: trackButtonClick, isApiInprogress: isApiInprogress, closeFocusLayer: closeFocusLayer, fsCheckoutLink: fsCheckoutLink }), focusLayerNode),
        !isRenderedInConversionBar && (React.createElement(StyledButton, { onClick: () => {
                openFocusLayer();
                trackButtonClick(buttonInfo, variant);
            }, variant: variant, "data-tracking-exclude": true, isFullWidth: isMobileScreenSize, isLoading: isLoading, "data-testid": "finance-checkout", "aria-label": financeCheckoutTranslations.financeCheckoutAriaBtn, size: dynamicStylingHelper('md', 'sm') }, buttonInfo.label))));
};
const StyledButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  @media (max-width: 479px) {
    width: 100%;
  }
`;
